<template>
    <div class="tbody">
        <template v-if="$mq === 'wide'">
            <div class="tr" v-for="(cate_list_value, cate_list_key) in cate_list" v-show="!cate_list_value.is_filtered"
                v-on:click="redirectUrl(cate_list_value)">
                <div class="td" v-for="(cate_title_value, cate_title_key) in storeResource.cate_title">
                    <template v-if="isGoodnotesUri(cate_title_value.lom_field.field.uri) && showGoodNotes(cate_list_value.content, cate_list_value.metadata_id)" >
                        <GoodNotes
                            :tooltip_string="lang($t('Sync to Goodnotes'))"
                            :resource_id="getResourceId(cate_list_value.metadata_id)"
                        />
                    </template>
                    <!-- download col -->
                    <template v-if="cate_title_value.lom_field.field.uri === 'hkepc:hkep-file'">
                        <HkepDisplayFormatSize v-bind:url="getFileApi + encodeFilename(cate_list_value.metadata_id)"
                            v-bind:fileType="getResourceContentData(cate_list_value, 'hkepc:technical/format', mime_type)"
                            v-bind:size="cate_list_value.size"
                            v-bind:download_display_type="storeResource.download_display_type"
                            v-bind:resource_url="getResourceContentData(cate_list_value, 'hkepc:hkep-url', mime_type)"
                            v-bind:filename="cate_list_value.file_name" v-bind:id="cate_list_value.metadata_id"
                            v-bind:preview_url="getPreviewFileApi + cate_list_value.metadata_id"
                            v-bind:has_preview="cate_list_value.has_preview_file" v-bind:item="cate_list_value">
                        </HkepDisplayFormatSize>
                    </template>
                    <template v-if="cate_title_value.lom_field.field.uri === 'hkepc:preview'">
                        <HkepPreviewButton v-bind:preview_url="getPreviewFileApi + cate_list_value.metadata_id"
                            v-bind:url="getFileApi + cate_list_value.metadata_id"
                            v-bind:has_preview="cate_list_value.has_preview_file"
                            v-bind:fileType="getResourceContentData(cate_list_value, 'hkepc:technical/format', mime_type)"
                            v-bind:id="cate_list_value.metadata_id" v-bind:item="cate_list_value"></HkepPreviewButton>
                    </template>
                    <template v-if="cate_title_value.lom_field.field.uri === 'hkepc:technical/size'">
                        <HkepDisplaySize v-bind:size="cate_list_value.size"></HkepDisplaySize>
                    </template>
                    <template v-else-if="cate_title_value.lom_field.field.uri === 'hkepc:hkep-url'">
                        <a class="btn-download"
                            :href="getResourceContentData(cate_list_value, 'hkepc:hkep-url', mime_type)"
                            target="_blank">
                            <div class="file-type dark">
                                <p class="dark file-url">URL</p>
                            </div>
                        </a>
                    </template>
                    <template v-else-if="cate_title_value.lom_field.field.uri === 'hkepc:checkbox'">
                        <HkepCheckBox v-bind:inputId="cate_list_value.row" v-bind:inputValue="cate_list_value.row"
                            v-bind:isDisabled="cate_list_value.allow_use && cate_list_value.allow_download"
                            v-bind:isChecked="cate_list_value.check"
                            v-bind:size="showGoodNotes(cate_list_value.content, cate_list_value.metadata_id) ? 10 : cate_list_value.size"
                            v-on:click.native="toggleCheck(cate_list_value, cate_list_value.row)">
                        </HkepCheckBox>
                        <HkepLabel
                            v-bind:labelFor="cate_list_value.row"
                            v-bind:size="showGoodNotes(cate_list_value.content, cate_list_value.metadata_id) ? 10 : cate_list_value.size"
                        ></HkepLabel>
                    </template>

                    <template v-else>
                        <template v-for="content_value in cate_list_value.content">
                            <template v-if="cate_title_value.lom_field.field.uri !== 'hkepc:technical/format'">

                                <template v-if="cate_title_value.lom_field.field.uri === content_value.key">

                                    <!-- show latex format -->
                                    <template
                                        v-if="cate_title_value.lom_field.field.uri === 'hkepc:general/description' && cate_list_value.file_type === 'latex'">
                                        <p id="latex_example">{{ content_value.value }}</p>

                                    </template>
                                    <template
                                        v-else-if="cate_title_value.lom_field.field.uri === 'hkepc:hkep-thumbnail'">
                                        <!--<img :src="cate_list_value.img">-->
                                        <hkep-thumbnail v-bind:url="cate_list_value.thumbnail_url"
                                            v-bind:image="getImageApi + content_value.value"
                                            v-bind:item="cate_list_value"></hkep-thumbnail>
                                    </template>

                                    <template
                                        v-else-if="cate_title_value.lom_field.field.uri.includes('hkep-classification')">
                                        <p>{{ getClassificationDisplayName(cate_title_value.options,
                                            content_value.value) }}</p>
                                    </template>

                                    <template
                                        v-else-if="cate_title_value.lom_field.field.uri === 'hkepc:contributes/date'">

                                        <p>{{ content_value.value.substring(0, 10) }}</p>
                                    </template>

                                    <template v-else>
                                        <!-- show normal content -->
                                        <div v-html="content_value.value" class="content_break"></div>
                                    </template>

                                </template>
                            </template>

                        </template>
                    </template>
                </div>
            </div>
        </template>
        <template v-if="$mq === 'narrow'">
            <div class="mobile-resources-box" v-for="(cate_list_value, cate_list_key) in cate_list"
                v-show="!cate_list_value.is_filtered" @click.self="toggleMobileFields(cate_list_key, $event)">
                <!-- cate_title can contain checkbox, but resource.content doesn't.  So we can safely put checkbox here -->
                <div v-for="(cate_title_value, cate_title_key) in storeResource.cate_title">
                    <template v-if="cate_title_value.lom_field.field.uri === 'hkepc:checkbox'">
                        <div class="checkbox" v-hascheck>
                            <HkepCheckBox v-bind:inputId="cate_list_value.row" v-bind:inputValue="cate_list_value.row"
                                v-bind:isDisabled="cate_list_value.allow_use && cate_list_value.allow_download"
                                v-bind:isChecked="cate_list_value.check"
                                v-bind:size="showGoodNotes(cate_list_value.content, cate_list_value.metadata_id) ? 10: cate_list_value.size"
                                v-on:click.native="toggleCheck(cate_list_value, cate_list_value.row)">
                            </HkepCheckBox>
                            <HkepLabel
                                v-bind:labelFor="cate_list_value.row"
                                v-bind:size="showGoodNotes(cate_list_value.content, cate_list_value.metadata_id) ? 10 : cate_list_value.size"
                            >
                            </HkepLabel>
                        </div>
                    </template>
                </div>


                <div v-for="(cate_title_value, cate_title_key) in firstRowOrCheckboxOnMobile">
                    <template v-for="content_value in cate_list_value.content">
                        <template v-if="cate_title_value.lom_field.field.uri === content_value.key">
                            <!-- show latex format -->
                            <template
                                v-if="cate_title_value.lom_field.field.uri === 'hkepc:general/description' && cate_list_value.file_type === 'latex'">
                                <div class="first-field" :class="classNarrowField">
                                    <p id="latex_example" @click.self="toggleMobileFields(cate_list_key, $event)">{{
                                        content_value.value }}</p>
                                </div>
                            </template>

                            <template v-else-if="cate_title_value.lom_field.field.uri === 'hkepc:hkep-thumbnail'">
                                <div class="first-field" :class="classNarrowField">
                                    <hkep-thumbnail v-bind:url="cate_list_value.thumbnail_url"
                                        v-bind:image="getImageApi + content_value.value" v-bind:item="cate_list_value"
                                        @click.self="toggleMobileFields(cate_list_key, $event)"></hkep-thumbnail>

                                </div>
                            </template>

                            <template v-else-if="cate_title_value.lom_field.field.uri === 'hkepc:general/title'">
                                <div class="first-field" :class="classNarrowField">
                                    <h1 class="field" @click.self="toggleMobileFields(cate_list_key, $event)"
                                        v-html="content_value.value"></h1>
                                </div>
                            </template>
                            <template v-else-if="cate_title_value.lom_field.field.uri.includes('hkep-classification')">

                                <div class="field" v-itemorder="storeResource.mobile_order[cate_title_key]"
                                    :class="classNarrowField">
                                    <h1>{{ getClassificationDisplayName(cate_title_value.options, content_value.value)
                                        }}</h1>
                                </div>
                            </template>

                            <template v-else>
                                <div class="first-field" :class="classNarrowField">
                                    <h1 @click.self="toggleMobileFields(cate_list_key, $event)"
                                        v-html="content_value.value"></h1>
                                </div>
                            </template>

                        </template>
                    </template>
                </div>

                <div class="mobile-hidden-rows-wrapper" :id="`mobile-hidden-rows-wrapper-${cate_list_key}`"
                    v-show="mobileFieldWrapperDisplay[cate_list_key] === true">
                    <div v-for="(cate_title_value, cate_title_key) in storeResource.cate_title">
                        <!-- file format and size is expected to always appear -->
                        <template
                            v-if="isNotFirstRowOnMobile(cate_title_key) && cate_title_value.lom_field.field.uri !== 'hkepc:technical/format'">
                            <template v-for="content_value in cate_list_value.content">
                                <template v-if="cate_title_value.lom_field.field.uri === content_value.key">

                                    <!-- show latex format -->
                                    <template
                                        v-if="cate_title_value.lom_field.field.uri === 'hkepc:general/description' && cate_list_value.file_type === 'latex'">
                                        <div class="field" :class="classNarrowField">
                                            <p id="latex_example">{{ content_value.value }}</p>
                                        </div>
                                    </template>

                                    <template
                                        v-else-if="cate_title_value.lom_field.field.uri === 'hkepc:hkep-thumbnail'">
                                        <div class="field" v-itemorder="storeResource.mobile_order[cate_title_key]"
                                            :class="classNarrowField">

                                            <hkep-thumbnail v-bind:url="cate_list_value.thumbnail_url"
                                                v-bind:image="getImageApi + content_value.value"
                                                v-bind:item="cate_list_value"></hkep-thumbnail>
                                        </div>
                                    </template>

                                    <template
                                        v-else-if="cate_title_value.lom_field.field.uri === 'hkepc:general/title'">
                                        <!-- title is expected to come first -->
                                        <div class="field" v-itemorder="storeResource.mobile_order[cate_title_key]"
                                            :class="classNarrowField">
                                            <p class="field">{{ content_value.value }}</p>
                                        </div>
                                    </template>

                                    <template
                                        v-else-if="cate_title_value.lom_field.field.uri.includes('hkep-classification')">

                                        <div class="field" v-itemorder="storeResource.mobile_order[cate_title_key]"
                                            :class="classNarrowField">
                                            <p>{{ getClassificationDisplayName(cate_title_value.options,
                                                content_value.value) }}</p>
                                        </div>
                                    </template>

                                    <template
                                        v-else-if="cate_title_value.lom_field.field.uri === 'hkepc:contributes/date'">
                                        <!-- show normal content -->
                                        <div class="field" v-itemorder="storeResource.mobile_order[cate_title_key]"
                                            :class="classNarrowField">
                                            <p>{{ content_value.value.substring(0, 10) }}</p>
                                        </div>
                                    </template>

                                    <template
                                        v-else-if="cate_title_value.lom_field.field.uri === 'hkepc:technical/size'">
                                    </template>

                                    <template v-else-if="cate_title_value.lom_field.field.uri === 'hkepc:hkep-url'">
                                    </template>

                                    <template v-else>
                                        <!-- show normal content -->
                                        <div class="field" v-itemorder="storeResource.mobile_order[cate_title_key]"
                                            :class="classNarrowField">
                                            <div v-html="content_value.value" class="content_break"></div>
                                        </div>
                                    </template>

                                </template>
                            </template>
                        </template>
                    </div>
                </div>

                <div class="mobile-action-buttons">
                    <div v-for="(cate_title_value, cate_title_key) in fileFormatAndSizeField">
                        <!-- Always show file format and size-->
                        <template v-if="cate_title_value.lom_field.field.uri === 'hkepc:hkep-file'">
                            <div class="field align-right" @click.self="toggleMobileFields(cate_list_key, $event)">
                                <HkepDisplayFormatSize v-bind:url="getFileApi + cate_list_value.metadata_id"
                                                       v-bind:fileType="getResourceContentData(cate_list_value, 'hkepc:technical/format', mime_type)"
                                                       v-bind:size="cate_list_value.size" v-bind:download_display_type="'double'"
                                                       v-bind:resource_url="getResourceContentData(cate_list_value, 'hkepc:hkep-url', mime_type)"
                                                       v-bind:filename="cate_list_value.file_name" v-bind:id="cate_list_value.metadata_id"
                                                       v-bind:preview_url="getPreviewFileApi + cate_list_value.metadata_id"
                                                       v-bind:has_preview="cate_list_value.has_preview_file"
                                                       v-bind:has_preview_column="checkHasPreviewCol(fileFormatAndSizeField)"
                                                       v-bind:item="cate_list_value"></HkepDisplayFormatSize>
                            </div>
                        </template>
                        <template v-if="isGoodnotesUri(cate_title_value.lom_field.field.uri)
                        && showGoodNotes(cate_list_value.content, cate_list_value.metadata_id)" >
                            <GoodNotes
                                :tooltip_string="lang($t('Sync to Goodnotes'))"
                                style="margin-left: 0.7rem; margin-right: 0.7rem;"
                                :resource_id="getResourceId(cate_list_value.metadata_id)"
                            />
                        </template>
                    </div>
                </div>


                <div v-for="(cate_title_value, cate_title_key) in UrlField">
                    <template v-if="cate_title_value.lom_field.field.uri === 'hkepc:hkep-url'">
                        <div class="field align-right" @click.self="toggleMobileFields(cate_list_key, $event)">
                            <a class="btn-download"
                                :href="getResourceContentData(cate_list_value, 'hkepc:hkep-url', mime_type)"
                                target="_blank">
                                <div class="file-type dark">
                                    <p class="dark file-url">URL</p>
                                </div>
                            </a>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </div>

</template>

<script>

import Vue from 'vue';
import { common } from '@mixins/common';
import { storeMapper } from '@mixins/storeMapper';
import EventBus from '@common/eventBus';
import HkepCheckBox from '@/HkepCheckBox';
import HkepLabel from '@/HkepLabel';
import HkepDisplayFormatSize from '@/HkepDisplayFormatSize';
import mime_type from '@json/mime_type'
import HkepDisplaySize from '@/HkepDisplaySize';
import HkepPreviewButton from '@/HkepPreviewButton';
import HkepThumbnail from "./HkepThumbnail";
import {URI} from "../../config/uri";
import GoodNotes from "./GoodNotes.vue";

export default {
    name: "SubCateListItem",
    data() {
        return {
            hasCheckbox: false, //whether checkbox exists in the listing, used in narrow screen (e.g. mobile)
            mobileFieldWrapperDisplay: [],
            getImageApi: getImageApi,
            getFileApi: getFileApi,
            getPreviewFileApi: getPreviewFileApi,
            displayedGoodNotes: {},
        }
    },
    components: {
        GoodNotes,
        HkepThumbnail,
        HkepCheckBox,
        HkepLabel,
        HkepDisplayFormatSize,
        HkepDisplaySize,
        HkepPreviewButton
    },
    directives: {
        itemorder: {
            bind(el, binding, vnode) {
                Vue.nextTick(() => {
                    vnode.elm.parentElement.style.order = binding.value;
                });

            }
        },
        hascheck: {
            bind(el, binding, vnode) {
                vnode.context.hasCheckbox = true;
            }
        }
    },
    mixins: [common, storeMapper],
    props: [
        "cate_list"
    ],
    computed: {
        URI() {
            return URI
        },
        mime_type() {
            return mime_type;
        },
        classNarrowField() {
            return this.hasCheckbox ? 'shift-right' : '';
        },
        /**
         * Whether the content field is expected to appear on the first row on mobile screen
         * We will separate the first row from other rows, so that we can apply slide animation
         * by wrapping the other fields inside  a <div>
         *
         * cate_title can contain checkbox, and mobile_order corresponds to cate_title.
         * But resource.content doesn't contain contentbox.  So we can just filter out 'checkbox' to ge the first row

         * cate_title sample:
         * 0: {display_name: "checkbox"..}
         * 1: {display_name: "URL"..}
         * 2: {display_name: "標題"..}
         * 3: {display_name: "內容"..}
         * 4: {display_name: "下載"..}

         * resource.content sample:
         * 0: {key: "hkep-thumbnail"....}
         * 1: {key: "hkepc:general/title"....}
         * 2: {key: "hkepc:general/description"....}
         * 3: {key: "hkepc:technical/format"....}
         * 4: {key: "hkepc:technical/size"....}

         * mobile_order sample:
         * mobile_order: [0, 2, 1, 3, 4]

         * In which mobile_order corresponds to cate_title; but checkbox will never match resource.content. So we can determine checkbox type individually
         *
         */
        firstRowOrCheckboxOnMobile() {
            return this.storeResource.cate_title.filter((value, index, item) => {
                return this.storeResource.mobile_order[0] === index && value.lom_field.field.uri !== 'hkepc:checkbox';
            })
        },
        /**
         * File format and size is expected to always appear. We handle the loop separately.
         * so that we can apply slide animation by wrapping the other fields inside  a <div>
         */
        fileFormatAndSizeField() {

            return this.storeResource.cate_title.filter((value, index, item) => {
                return (
                    value.lom_field.field.uri === 'hkepc:hkep-file'
                    || value.lom_field.field.uri === 'hkepc:preview'
                    || value.lom_field.field.uri === URI.GOODNOTES
                    || value.lom_field.field.uri === URI.GOODNOTES_EN
                );
            })

        },
        UrlField() {

            return this.storeResource.cate_title.filter((value, index, item) => {
                return value.lom_field.field.uri === 'hkepc:hkep-url';
            })

        }
    },
    methods: {
        checkHasPreviewCol(array_col) {
            let result = false;
            if (array_col) {
                array_col.forEach(function (item) {
                    if (item.lom_field.field.uri === 'hkepc:preview') {
                        result = true;
                    }
                });
            }

            return result;
        },
        /**
         *
         * 從classification的值 取得 對應的顯示名稱
         *
         * @param arr_options array
         * @param key string xxx or xxx,xxw
         *
         * @return string
         * */
        getClassificationDisplayName(arr_options, key) {
            var name = "";
            if (arr_options) {

                var arr_value = key.split(",");
                if (arr_value) {
                    arr_value.forEach(function (code, index) {
                        arr_options.forEach(function (obj) {
                            if (obj.id === code) {
                                if (index + 1 === arr_value.length) {
                                    name += obj.value;

                                } else {
                                    name += obj.value + ", ";

                                }
                            }
                        });
                    })

                }

            }

            return name;

        },
        toggleCheck: function (item, index) {
            if (item.allow_use === true && item.allow_download === true) {
                if (!item.check) {
                    Vue.set(item, 'check', true);
                    this.$store.commit("resource_store/add", item);
                } else {
                    Vue.set(item, 'check', false);
                    this.$store.commit("resource_store/remove", item);
                }
            }
        },
        /**
         * Determine if second row on onwards on mobile screen
         * If has checkbox, the first row order should be 1, otherwise 0.
         * So check if first row order is greater than 1.
         */
        isNotFirstRowOnMobile(cate_title_key) {
            return this.storeResource.mobile_order[0] !== cate_title_key;
        },
        /**
         * Show/hide the mobile main fields
         */
        toggleMobileFields(cate_list_key, event) {
            Vue.set(this.mobileFieldWrapperDisplay, cate_list_key, !this.mobileFieldWrapperDisplay[cate_list_key]);
            //let fields = document.querySelector(`#mobile-hidden-rows-wrapper-${cate_list_key}`);
            //fields.style.display = (fields.style.display === "flex") ? "none" : "flex";
        },
        /**
         * onclick redirect to other page (只適合 最新消息)
         * @param obj
         */
        redirectUrl(obj) {

            if (obj.url) {
                window.open(obj.url, '_blank');
            }

        },
        showGoodNotes(obj, metadata_id) {
            let shouldShow = Array.isArray(obj) && obj.some(item => item.value === URI.OPEN_GOODNOTES);
            if (shouldShow) {
                if (!this.displayedGoodNotes[metadata_id]) {
                    Vue.set(this.displayedGoodNotes, metadata_id, true);
                }
                return true;
            }
            return false;
        },
        isGoodnotesUri(uri) {
            return [URI.GOODNOTES, URI.GOODNOTES_EN].includes(uri);
        }
    }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// resources/assets/js/components/SubCateListItem.vue